<svelte:head>

    <title>Login • keyosh</title>

</svelte:head>

<script>
    import Login from "../components/login.svelte"
</script>


<section>

    <Login />

</section>


<style>

    section {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: inherit;
    }

</style>
